import $ from "jquery";

const SocialShare = (() => {
  return {
    initialize: function (selector, selectorMenu) {
      const $socialShares = $(selector);
      $socialShares.each(function(index, element) {
        let $socialShare = $(element);
        let $socialMenu = $socialShare.find(selectorMenu);
        $socialShare.click(function() {
          $socialMenu.stop(true, false).slideToggle();
        });
      });
    },
  };
})();

module.exports = SocialShare;
